import { stringify } from 'query-string';

import { QueryParams } from '@m/types';
import { CreateEnterpriseSubscriptionRequestBody, EntSubUpdatePayload } from '@m/types/api';
import { apiFetch } from '@m/utils/http';

import { RemitData } from '../components/Invoice/InvoicePDF/types';

export const EnterpriseSubscriptionService = {
  list: ({ entId }: { entId: number }) => apiFetch(`/admin/enterprise/${entId}/subscriptions`),

  create: ({
    enterpriseId,
    body,
  }: {
    body: CreateEnterpriseSubscriptionRequestBody;
    enterpriseId: number;
  }) =>
    apiFetch(`/admin/enterprise/${enterpriseId}/subscriptions`, {
      method: 'POST',
      body,
    }),

  details: ({ entId, subId }: { entId: number; subId: number }) =>
    apiFetch(`/admin/enterprise/${entId}/subscriptions/${subId}`),

  update: ({
    entId,
    subId,
    payload: body,
  }: {
    entId: number;
    payload: EntSubUpdatePayload;
    subId: number;
  }) =>
    apiFetch(`/admin/enterprise/${entId}/subscriptions/${subId}`, {
      method: 'PUT',
      body,
    }),

  cancel: ({ subscriptionIds }: { subscriptionIds: number[] }) =>
    apiFetch('/admin/enterprise/subscriptions/cancel', {
      method: 'POST',
      body: { subscriptionIds },
    }),

  addMember: ({
    entId,
    subId,
    ...userInfo
  }: {
    email?: string;
    entId: number;
    phone?: string;
    subId: number;
    vehiclePlate?: string;
  }) => {
    const endpoint = userInfo.vehiclePlate ? 'add-vehicle' : 'add-user';
    return apiFetch(
      `/admin/enterprise/${entId}/subscriptions/${subId}/${endpoint}?${stringify(userInfo as QueryParams)}`,
      { method: 'POST' },
    );
  },

  deleteMembers: ({ entId, subId, userIds }: { entId: number; subId: number; userIds: number[] }) =>
    apiFetch(`/admin/enterprise/${entId}/subscriptions/${subId}/members`, {
      method: 'DELETE',
      body: {
        userIds,
      },
    }),

  createRedemptionCode: ({ entId, subId }: { entId: number; subId: number }) =>
    apiFetch(`/admin/enterprise/${entId}/subscriptions/${subId}/redemption-codes`, {
      method: 'POST',
    }),

  getRedemptionCode: ({ entId, subId }: { entId: number; subId: number }) =>
    apiFetch(`/admin/enterprise/${entId}/subscriptions/${subId}/redemption-codes`),

  getRemitAddressPortal: ({ entId }: { entId: number }) =>
    apiFetch<RemitData>(`/portal/enterprise/${entId}/remit-address`, {
      method: 'POST',
    }),

  getRemitAddress: ({ entId }: { entId: number }) =>
    apiFetch<RemitData>(`/admin/enterprise/${entId}/remit-address`, {
      method: 'GET',
    }),
};
